import { render, staticRenderFns } from "./disposition.vue?vue&type=template&id=0f1fc6f8&scoped=true"
import script from "./disposition.vue?vue&type=script&lang=js"
export * from "./disposition.vue?vue&type=script&lang=js"
import style0 from "./disposition.vue?vue&type=style&index=0&id=0f1fc6f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1fc6f8",
  null
  
)

export default component.exports